/* PRISKEL REDESIGN — product page: gallery, variants, Stack & Save, add to bag, buy now,
   delivery estimate, sticky bar, complete the look, reels, reviews. */
(function () {
  if (window.PKPD) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function inr(p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); }
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || document).querySelectorAll(s)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function openBag() {
    var bag = $('.pk-hd__bag') || $('a[href="/cart"].hdt-has-count-box') || $('[data-cart-toggle]');
    if (bag) bag.click(); else location.href = root + 'cart';
  }
  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; });
    }).then(function (j) {
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        $$('hdt-cart-count, [data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; });
        try { document.dispatchEvent(new CustomEvent('cart:count:update', { detail: { item_count: cart.item_count } })); } catch (e) {}
        return cart;
      });
    });
  }

  /* ---------------- main product ---------------- */
  function main(sec) {
    if (sec.dataset.ready) return; sec.dataset.ready = 1;
    var data = {};
    try { data = JSON.parse($('[data-pkp-json]', sec).textContent); } catch (e) { data = { variants: [] }; }
    var t2 = +sec.dataset.t2 || 0, t3 = +sec.dataset.t3 || 0, low = +sec.dataset.low || 5;
    var variant = null;
    var idInput = $('[data-pkp-id]', sec);
    data.variants.forEach(function (v) { if (idInput && +idInput.value === v.id) variant = v; });
    variant = variant || data.variants[0];

    /* gallery */
    var track = $('[data-pkp-track]', sec), slides = $$('[data-pkp-slide]', sec), thumbs = $$('[data-pkp-thumb]', sec);
    var prog = $('[data-pkp-prog]', sec), cur = $('[data-pkp-cur]', sec);
    var prev = $('[data-pkp-prev]', sec), next = $('[data-pkp-next]', sec);
    var idx = 0;
    function current() {
      if (!track || !slides.length) return 0;
      var x = track.scrollLeft, best = 0, d = 1e9;
      slides.forEach(function (s, i) { var dd = Math.abs(s.offsetLeft - track.offsetLeft - x); if (dd < d) { d = dd; best = i; } });
      if (x >= track.scrollWidth - track.clientWidth - 4) best = slides.length - 1;
      return best;
    }
    function paint() {
      idx = current();
      var n = slides.length || 1;
      if (prog) { prog.style.width = (100 / n) + '%'; prog.style.left = (idx * 100 / n) + '%'; }
      if (cur) cur.textContent = pad(idx + 1);
      thumbs.forEach(function (t, i) { t.classList.toggle('is-on', i === idx); });
      var on = thumbs[idx]; if (on && on.parentNode.scrollHeight > on.parentNode.clientHeight) {
        var p = on.parentNode, top = on.offsetTop - p.offsetTop;
        if (top < p.scrollTop || top + on.offsetHeight > p.scrollTop + p.clientHeight) p.scrollTo({ top: top - 20, behavior: 'smooth' });
      }
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx >= n - 1;
      slides.forEach(function (s, i) {
        var v = s.querySelector('video'); if (!v) return;
        if (i === idx) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else v.pause();
      });
    }
    function go(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false || reduce ? 'auto' : 'smooth' });
    }
    if (track) {
      var raf = null;
      track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; paint(); }); }, { passive: true });
      window.addEventListener('resize', paint);
      paint();
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(idx + 1, slides.length - 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(idx - 1, 0)); }
      });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    if (prev) prev.addEventListener('click', function () { go(Math.max(idx - 1, 0)); });
    if (next) next.addEventListener('click', function () { go(Math.min(idx + 1, slides.length - 1)); });

    /* zoom */
    var zd = $('[data-pkp-zoomdlg]', sec);
    if (zd) {
      sec.addEventListener('click', function (e) {
        var z = e.target.closest('[data-pkp-zoom]'); if (!z) return;
        var n = z.getAttribute('data-pkp-zoom');
        if (typeof zd.showModal === 'function') zd.showModal(); else zd.setAttribute('open', '');
        document.documentElement.classList.add('pk-lock');
        var f = $('[data-pkp-zimg="' + n + '"]', zd);
        $$('img', zd).forEach(function (im) { im.loading = 'eager'; });
        if (f) setTimeout(function () { f.scrollIntoView({ block: 'start' }); }, 30);
      });
      function zclose() { if (zd.open) { zd.close ? zd.close() : zd.removeAttribute('open'); } document.documentElement.classList.remove('pk-lock'); }
      $('[data-pkp-zclose]', zd).addEventListener('click', zclose);
      zd.addEventListener('close', function () { document.documentElement.classList.remove('pk-lock'); });
      zd.addEventListener('click', function (e) { if (e.target.tagName === 'IMG') zclose(); });
    }

    /* variants */
    var opts = $$('[data-pkp-opt]', sec);
    function selected() { return opts.map(function (o) { var b = $('.pk-pd__pill.is-on', o); return b ? b.getAttribute('data-val') : null; }); }
    function find(sel) { for (var i = 0; i < data.variants.length; i++) { var v = data.variants[i]; if (v.options.every(function (o, j) { return o === sel[j]; })) return v; } return null; }
    function markAvailability() {
      var sel = selected();
      opts.forEach(function (o, oi) {
        $$('.pk-pd__pill', o).forEach(function (b) {
          var test = sel.slice(); test[oi] = b.getAttribute('data-val');
          var v = find(test); b.classList.toggle('is-na', !v || !v.available);
        });
      });
    }
    opts.forEach(function (o) {
      o.addEventListener('click', function (e) {
        var b = e.target.closest('.pk-pd__pill'); if (!b) return;
        $$('.pk-pd__pill', o).forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
        var lab = $('[data-pkp-optval]', o); if (lab) lab.textContent = b.getAttribute('data-val');
        var v = find(selected());
        if (v) setVariant(v);
        markAvailability();
      });
    });
    if (opts.length) markAvailability();

    function stockHTML(v) {
      if (!v.available) return '<div class="pk-pd__av is-out"><i class="pk-pd__sdot" aria-hidden="true"></i><p><b>Sold out</b> · back soon</p></div>';
      if (v.qty > 0 && v.qty <= low) { var m = Math.max(8, Math.floor(v.qty * 100 / low / 3)); return '<div class="pk-pd__av is-low"><span class="pk-pd__avi"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="13" r="7.5"/><path d="M12 9.5V13l2.2 1.6M9.5 3h5M6 6 4.5 4.5M18 6l1.5-1.5"/></svg></span><p><b>Only ' + v.qty + ' left</b> · ships in 1–2 days</p><span class="pk-pd__meter" aria-hidden="true"><i style="width:' + m + '%"></i></span></div>'; }
      return '<div class="pk-pd__av"><i class="pk-pd__sdot" aria-hidden="true"></i><p><b>In stock</b> · ready to ship in 1–2 days</p></div>';
    }
    function setVariant(v) {
      variant = v;
      if (idInput) idInput.value = v.id;
      var now = $('[data-pkp-now]', sec), was = $('[data-pkp-was]', sec), sv = $('[data-pkp-save]', sec);
      if (now) now.textContent = inr(v.price);
      var save = v.compare > v.price ? v.compare - v.price : 0;
      if (was) { was.textContent = inr(v.compare); was.hidden = !save; }
      if (sv) { sv.textContent = 'Save ' + inr(save); sv.hidden = !save; }
      var st = $('[data-pkp-stock]', sec); if (st) st.innerHTML = stockHTML(v);
      var pre = $('[data-pkp-pre]', sec);
      if (pre) { var off = Math.min(Math.floor(v.price * (+sec.dataset.pre || 0) / 100 / 100) * 100, (+sec.dataset.cap || 0) * 100); pre.textContent = inr(v.price - off); }
      var t1 = $('[data-pkp-t1]', sec); if (t1) t1.textContent = inr(v.price);
      var sk = $('[data-pkp-sknow]'); if (sk) sk.textContent = inr(v.price);
      var buy = $('[data-pkp-buy]', sec); if (buy) buy.hidden = !v.available;
      if (v.media) { slides.forEach(function (s, i) { if (+s.getAttribute('data-media-id') === v.media) go(i); }); }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
      stackPaint();
    }

    /* Stack & Save */
    var tier = 1, stack = $('[data-pkp-stack]', sec), pairBox = $('[data-pkp-pair]', sec);
    var picks = $$('[data-pkp-pick]', sec);
    function chosen() { return picks.filter(function (p) { return p.checked; }); }
    function stackPaint() {
      var atcL = $('[data-pkp-atcl]', sec), atc = $('[data-pkp-atc]', sec);
      var extra = chosen(), n = 1 + extra.length;
      var sub = variant.price; extra.forEach(function (p) { sub += +p.dataset.price; });
      var pct = n >= 3 ? t3 : (n === 2 ? t2 : 0);
      var off = Math.floor(sub * pct / 100 / 100) * 100;
      if (stack) {
        var s2 = $('[data-pkp-s2]', stack), s3 = $('[data-pkp-s3]', stack);
        if (n === 2 && s2) s2.textContent = 'Save ' + inr(off);
        if (n >= 3 && s3) s3.textContent = 'Save ' + inr(off);
        var hl = picks.length ? Math.min(n, 3) : tier;
        $$('[data-pkp-tier]', stack).forEach(function (b) {
          var on = +b.getAttribute('data-pkp-tier') === hl;
          b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }
      if (!atc || !atcL) return;
      if (!variant.available) { atc.disabled = true; atcL.textContent = 'Sold out'; return; }
      atc.disabled = false;
      atcL.textContent = n === 1 ? 'Add to bag · ' + inr(variant.price) : 'Add ' + n + ' to bag · save ' + inr(off);
    }
    if (stack) {
      stack.addEventListener('click', function (e) {
        var b = e.target.closest('[data-pkp-tier]'); if (!b) return;
        tier = +b.getAttribute('data-pkp-tier');
        if (pairBox) pairBox.hidden = tier === 1;
        picks.forEach(function (p, i) { p.checked = i < tier - 1; });
        stackPaint();
      });
      picks.forEach(function (p) { p.addEventListener('change', function () { tier = Math.min(1 + chosen().length, 3); stackPaint(); }); });
    }
    stackPaint();

    /* add to bag */
    var msg = $('[data-pkp-msg]', sec);
    function addMain(btn) {
      if (!variant || !variant.available) return;
      var label = btn.innerHTML;
      var items = [{ id: variant.id, quantity: 1 }];
      chosen().forEach(function (p) { items.push({ id: +p.dataset.id, quantity: 1 }); });
      btn.disabled = true; btn.textContent = 'Adding…'; if (msg) msg.textContent = '';
      addItems(items).then(function () {
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.disabled = false; btn.innerHTML = label; openBag(); }, 450);
      }).catch(function (err) {
        btn.disabled = false; btn.innerHTML = label;
        if (msg) msg.textContent = err.message || 'Something went wrong. Please try again.';
      });
    }
    var atc = $('[data-pkp-atc]', sec);
    if (atc) atc.addEventListener('click', function () { addMain(atc); });
    var form = $('[data-pkp-form]', sec);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); if (atc) addMain(atc); }, true);

    /* sticky */
    var sticky = $('[data-pkp-sticky]', sec), skbtn = $('[data-pkp-skatc]', sec);
    if (sticky && atc && 'IntersectionObserver' in window) {
      var past = false, foot = false;
      function upd() {
        var on = past && !foot;
        sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (skbtn) skbtn.tabIndex = on ? 0 : -1;
        document.body.classList.toggle('pk-sk-on', on);
      }
      new IntersectionObserver(function (en) { en.forEach(function (x) { past = !x.isIntersecting && x.boundingClientRect.top < 0; }); upd(); }).observe($('.pk-pd__btns', sec) || atc);
      var ft = $('.pk-ft') || $('footer');
      if (ft) new IntersectionObserver(function (en) { en.forEach(function (x) { foot = x.isIntersecting; }); upd(); }).observe(ft);
      if (skbtn) skbtn.addEventListener('click', function () { addMain(skbtn); });
    }

    /* read more */
    var more = $('[data-pkp-more]', sec), intro = $('[data-pkp-intro]', sec);
    if (more && intro) {
      requestAnimationFrame(function () { if (intro.scrollHeight <= intro.clientHeight + 2) more.hidden = true; });
      more.addEventListener('click', function () {
        var box = more.parentNode, open = !box.classList.contains('is-open');
        box.classList.toggle('is-open', open); more.textContent = open ? 'Read less' : 'Read more'; more.setAttribute('aria-expanded', open);
      });
    }

    /* delivery estimate */
    var min = +sec.dataset.min || 3, max = +sec.dataset.max || 6, cut = +sec.dataset.cut || 14;
    var eta = $('[data-pkp-eta]', sec), pin = $('[data-pkp-pin]', sec), pmsg = $('[data-pkp-pinmsg]', sec);
    var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function ist() { var d = new Date(); return new Date(d.getTime() + (d.getTimezoneOffset() + 330) * 60000); }
    function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; } return d; }
    function range(extra) {
      var now = ist(), late = now.getHours() >= cut || now.getDay() === 0 ? 1 : 0;
      var a = addBiz(now, min + late + extra), b = addBiz(now, max + late + extra);
      var fa = DAYS[a.getDay()] + ' ' + a.getDate() + (a.getMonth() !== b.getMonth() ? ' ' + MON[a.getMonth()] : '');
      return fa + ' – ' + DAYS[b.getDay()] + ' ' + b.getDate() + ' ' + MON[b.getMonth()];
    }
    if (eta) eta.innerHTML = 'Free delivery by <b>' + range(0) + '</b>';
    var cdEl = $('[data-pkp-cd]', sec);
    function tick() {
      if (!cdEl) return;
      if (!variant || !variant.available) { cdEl.hidden = true; return; }
      var now = ist(), end = new Date(now); end.setHours(cut, 0, 0, 0);
      if (now.getDay() === 0 || now >= end) { cdEl.hidden = true; return; }
      var mins = Math.ceil((end - now) / 60000), h = Math.floor(mins / 60), mm = mins % 60;
      var fd = addBiz(now, min), first = DAYS[fd.getDay()] + ' ' + fd.getDate() + ' ' + MON[fd.getMonth()];
      cdEl.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3a9 9 0 1 0 9 9"/><path d="M12 7v5l3 2M17 3.5h4v4"/></svg><span>Order within <b>' + (h ? h + 'h ' : '') + mm + 'm</b> for delivery from <b>' + first + '</b></span>';
      cdEl.hidden = false;
    }
    tick(); setInterval(tick, 30000);
    var REMOTE = /jammu|kashmir|ladakh|arunachal|assam|manipur|meghalaya|mizoram|nagaland|sikkim|tripura|andaman|lakshadweep/i;
    var saved = null; try { saved = localStorage.getItem('pk_pin'); } catch (e) {}
    function check(code) {
      if (!/^[1-9][0-9]{5}$/.test(code)) { pmsg.className = 'pk-pd__pinmsg is-err'; pmsg.textContent = 'Please enter a valid 6-digit pincode.'; return; }
      try { localStorage.setItem('pk_pin', code); } catch (e) {}
      pmsg.className = 'pk-pd__pinmsg'; pmsg.textContent = 'Checking ' + code + '…';
      var done = function (place, state) {
        var extra = REMOTE.test(state || '') ? 2 : 0;
        if (eta) eta.innerHTML = 'Free delivery by <b>' + range(extra) + '</b>';
        pmsg.className = 'pk-pd__pinmsg is-ok';
        pmsg.textContent = (place ? 'Delivering to ' + place + (state ? ', ' + state : '') + '. ' : 'Delivering to ' + code + '. ') + 'COD available on most pincodes, confirmed at checkout.';
      };
      var ctl = window.AbortController ? new AbortController() : null;
      var to = setTimeout(function () { if (ctl) ctl.abort(); }, 4000);
      fetch('https://api.postalpincode.in/pincode/' + code, ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.json(); }).then(function (j) {
        clearTimeout(to);
        var r = j && j[0];
        if (r && r.Status === 'Success' && r.PostOffice && r.PostOffice.length) { var po = r.PostOffice[0]; done(po.District, po.State); }
        else if (r && r.Status === 'Error') { pmsg.className = 'pk-pd__pinmsg is-err'; pmsg.textContent = 'We couldn’t find ' + code + '. Please check the pincode.'; }
        else done('', '');
      }).catch(function () { clearTimeout(to); done('', ''); });
    }
    if (pin && pmsg) {
      var inp = $('input', pin);
      if (saved && inp) inp.value = saved;
      inp.addEventListener('input', function () { inp.value = inp.value.replace(/\D/g, '').slice(0, 6); });
      pin.addEventListener('submit', function (e) { e.preventDefault(); check(inp.value.trim()); });
    }
  }

  /* buy now fallback (when Shiprocket checkout is not available) */
  function buyNow(e) {
    var btn = e && e.currentTarget, sec = btn && btn.closest('[data-pkp]');
    var id = sec && $('[data-pkp-id]', sec);
    if (!id) return;
    btn.disabled = true;
    addItems([{ id: +id.value, quantity: 1 }]).then(function () { location.href = root + 'checkout'; }).catch(function () { btn.disabled = false; });
  }

  /* ---------------- complete the look ---------------- */
  function look(sec) {
    if (sec.dataset.ready) return; sec.dataset.ready = 1;
    var rail = $('[data-pkp-lrail]', sec), p = $('[data-pkp-lprev]', sec), n = $('[data-pkp-lnext]', sec);
    function upd() {
      if (!rail) return;
      var max = rail.scrollWidth - rail.clientWidth;
      if (p) p.disabled = rail.scrollLeft < 4;
      if (n) n.disabled = rail.scrollLeft > max - 4;
      var nav = $('.pk-cl__nav', sec); if (nav) nav.style.visibility = max > 4 ? 'visible' : 'hidden';
    }
    function step(d) { var c = $('.pk-cl__card', rail); var w = c ? c.getBoundingClientRect().width + 22 : rail.clientWidth; rail.scrollBy({ left: d * w, behavior: reduce ? 'auto' : 'smooth' }); }
    if (rail) { rail.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd(); }
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pkp-qadd]'); if (!b) return;
      var lab = $('span', b), t = lab ? lab.textContent : '';
      b.disabled = true; if (lab) lab.textContent = 'Adding';
      addItems([{ id: +b.getAttribute('data-pkp-qadd'), quantity: 1 }]).then(function () {
        b.classList.add('is-done'); if (lab) lab.textContent = 'Added';
        setTimeout(function () { b.disabled = false; b.classList.remove('is-done'); if (lab) lab.textContent = t; }, 2200);
      }).catch(function () { b.disabled = false; if (lab) lab.textContent = t; });
    });
  }

  /* ---------------- worn in real life ---------------- */
  function worn(sec) {
    if (sec.dataset.ready) return; sec.dataset.ready = 1;
    var tiles = $$('[data-pkp-reel]', sec);
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          var v = $('video', x.target); if (!v) return;
          if (!x.isIntersecting) v.pause();
        });
      }, { threshold: [0, .6] });
      tiles.forEach(function (t) { io.observe(t); });
    }
    tiles.forEach(function (t) {
      var v = $('video', t); if (!v) return;
      v.addEventListener('play', function () { t.classList.add('is-playing'); });
      v.addEventListener('pause', function () { t.classList.remove('is-playing'); });
    });
    sec.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-pkp-reel]');
      if (tile && !e.target.closest('[data-pkp-snd]')) {
        var tv = $('video', tile); if (!tv) return;
        if (tv.paused) { tv.preload = 'auto'; var tp = tv.play(); if (tp && tp.catch) tp.catch(function () {}); } else tv.pause();
        return;
      }
      var b = e.target.closest('[data-pkp-snd]'); if (!b) return;
      var v = $('video', b.closest('[data-pkp-reel]')); if (!v) return;
      var on = v.muted;
      $$('video', sec).forEach(function (o) { o.muted = true; });
      $$('[data-pkp-snd]', sec).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); o.setAttribute('aria-label', 'Turn sound on'); });
      v.muted = !on; if (on) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
    });
  }

  /* ---------------- reviews ---------------- */
  var KEYS = {
    shower: /shower|bath|swim|pool|beach|sea\b|ocean|water|rain|monsoon|humid/i,
    gym: /gym|workout|work out|sweat|run\b|running|yoga|exercise|training|pilates|dance/i,
    gift: /gift|gifted|mom\b|mother|wife|sister|girlfriend|fianc|daughter|birthday|anniversary|friend/i,
    'months later': /month|months|weeks|fortnight|year|still look|day one|brand new|since/i
  };
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function reviews(sec) {
    if (sec.dataset.ready) return; sec.dataset.ready = 1;
    var shop = sec.dataset.shop, pid = sec.dataset.pid, total = +sec.dataset.count || 0;
    var list = $('[data-pkp-rlist]', sec), moreB = $('[data-pkp-rmore]', sec), empty = $('[data-pkp-rempty]', sec), photos = $('[data-pkp-photos]', sec);
    var all = [], page = 0, pages = 1, busy = false, filter = '', shown = 3, PER = 30;
    function url(p) { return 'https://judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&page=' + p + '&per_page=' + PER + '&product_id=' + pid; }
    function load() {
      if (busy || page >= pages) return Promise.resolve();
      busy = true;
      return fetch(url(page + 1)).then(function (r) { return r.json(); }).then(function (j) {
        page += 1; pages = (j.pagination && j.pagination.total_pages) || page;
        all = all.concat(j.reviews || []); busy = false; paintPhotos();
      }).catch(function () { busy = false; pages = page; });
    }
    function card(r) {
      var d = r.created_at ? new Date(r.created_at) : null;
      var date = d ? d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '';
      var pics = (r.pictures_urls || []).slice(0, 4).map(function (p) { var u = p.compact || p.small || p.original || p; return '<img src="' + esc(u) + '" alt="" loading="lazy">'; }).join('');
      return '<li class="pk-rw__card"><div class="pk-rw__top"><span class="pk-stars5" role="img" aria-label="' + r.rating + ' out of 5 stars" style="--r:' + (r.rating * 20) + '%"></span><b>' + esc(r.reviewer_name) + '</b><time>' + date + '</time></div><div class="pk-rw__body">' + (r.body_html || '') + '</div>' + (pics ? '<div class="pk-rw__pics">' + pics + '</div>' : '') + '</li>';
    }
    function match(r) { return !filter || (KEYS[filter] || new RegExp(filter, 'i')).test((r.body_html || '').replace(/<[^>]+>/g, ' ')); }
    function paint() {
      var m = all.filter(match);
      list.innerHTML = m.slice(0, shown).map(card).join('');
      empty.hidden = m.length > 0;
      if (!m.length) empty.textContent = 'No reviews mention “' + filter + '” yet in the latest ' + all.length + '. Try another topic.';
      if (moreB) moreB.hidden = !(m.length > shown || (page < pages));
    }
    function paintPhotos() {
      if (!photos) return;
      var ps = [];
      all.forEach(function (r) { (r.pictures_urls || []).forEach(function (p) { ps.push(p.compact || p.small || p.original || p); }); });
      if (!ps.length) return;
      var extra = ps.length > 4 ? ps.length - 3 : 0, view = extra ? ps.slice(0, 3) : ps.slice(0, 4);
      photos.innerHTML = view.map(function (u) { return '<li><img src="' + esc(u) + '" alt="Customer photo" loading="lazy"></li>'; }).join('') + (extra ? '<li class="is-more"><a href="#" data-pkp-allphotos>+' + extra + '</a></li>' : '');
      photos.hidden = false;
    }
    if (total > 0) load().then(function () { if (all.length) paint(); });
    if (moreB) moreB.addEventListener('click', function () {
      shown += 5;
      var need = all.filter(match).length < shown && page < pages;
      (need ? load() : Promise.resolve()).then(paint);
    });
    $$('[data-pkp-chip]', sec).forEach(function (c) {
      c.addEventListener('click', function () {
        filter = (c.getAttribute('data-pkp-chip') || '').toLowerCase();
        $$('[data-pkp-chip]', sec).forEach(function (o) { o.classList.toggle('is-on', o === c); o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
        shown = 5;
        var p = Promise.resolve();
        if (filter && page < Math.min(pages, 3)) p = load().then(function () { return page < Math.min(pages, 3) ? load() : null; });
        list.style.opacity = '.4';
        p.then(function () { list.style.opacity = ''; paint(); });
      });
    });
    sec.addEventListener('click', function (e) {
      if (e.target.closest('[data-pkp-allphotos]')) { e.preventDefault(); shown = 30; filter = ''; paint(); list.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
    var write = $('[data-pkp-write]', sec), app = $('[data-pkp-japp]', sec);
    if (write && app) write.addEventListener('click', function () {
      write.setAttribute('aria-expanded', 'true');
      var tries = 0;
      (function clickJm() {
        var b = [].slice.call(app.querySelectorAll('button, a')).filter(function (x) { return /write a review/i.test(x.textContent); })[0];
        if (b) { b.click(); return; }
        if (++tries < 20) setTimeout(clickJm, 150); else { app.hidden = false; app.scrollIntoView({ behavior: 'smooth' }); }
      })();
    });
  }

  function run() {
    $$('[data-pkp]').forEach(main);
    $$('[data-pkp-look]').forEach(look);
    $$('[data-pkp-worn]').forEach(worn);
    $$('[data-pkp-rv]').forEach(reviews);
  }
  window.PKPD = { buyNow: buyNow };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
